/**
 * mwApp.liveEvents module <br>
 * Work with LiveEvents: show/add/edit/remove
 *
 * @namespace mwApp/liveEvents
 */

import leConfig from './liveEvents.config'
import LiveEventsCtrl from './liveEvents.controller'
import AddLiveEventCtrl from './addLiveEvent.controller'

export default
angular.module('mwApp.liveEvents', [])
  .config(leConfig)
  .controller('LiveEventsCtrl', LiveEventsCtrl)
  .controller('AddLiveEventCtrl', AddLiveEventCtrl)
